export default {

    notificationConfiguration: 'Configuración de Notificaciones',
    selectNotificationOption: 'Selecciona las notificaciones que deseas recibir: ',
    emailNotifications: 'Notificaciones por Correo Electrónico',
    smsNotifications: 'Notificaciones por SMS',
    updatePersonalInformation: 'Actualizar Información Personal',
    updatePersonalInformationError: 'Ha ocurrido un error al actualizar tu información',
    securityConfuguration: 'Configuración de Seguridad',
    MF2: 'Autenticación en dos pasos (2FA)',
    MF2Description: 'Esta opción activa la autenticación con doble factor utilizando la aplicación de Google Authenticator.',
    MF2Error: 'Error al cambiar el estado de 2FA:',
};
